import { useContext } from 'react'

import AcessoContext from 'Components/Acesso/Context'

const useAcesso = () => useContext(AcessoContext)

export default useAcesso
